import { useDesignBoardCollaboratorsContext } from '@modules/design-board/component/manage/collaborator-overview/context/DesignBoardCollaboratorsContext';
import {
    Dialog,
    Flex,
    Grid,
    pxArrayToRem,
    pxToRem,
    useStyles,
} from '@archipro-design/aria';
import * as S from './ManageModal.style';
import type { ReactNode, SyntheticEvent } from 'react';

interface ManageModalProps {
    render: {
        left: ReactNode;
        right: ReactNode;
    };
}
export const ManageModal = ({ render }: ManageModalProps) => {
    const ctx = useDesignBoardCollaboratorsContext();
    const { css } = useStyles();

    if (ctx.state.visibility === 'hidden') {
        return null;
    }

    const handleBackgroundClick = (e: SyntheticEvent<HTMLElement>) => {
        if (!(e.target === e.currentTarget)) {
            return;
        }
        e.stopPropagation();
        ctx.dispatch({
            type: 'modal-visibility',
            data: {
                visibility: 'hidden',
            },
        });
    };

    return (
        <Dialog
            open={ctx.state.visibility === 'visible'}
            overlay={{
                style: {
                    background: 'rgba(0, 0, 0, 0.45)',
                },
            }}
            onCancel={handleBackgroundClick}
            style={{
                padding: 0,
                borderTop: 'none',
                margin: 0,
                width: pxToRem(1100),
                borderRadius: 0,
            }}
            variables={{
                rootWidth: '100%',
                padding: 0,
            }}
            footer={null}
            content={{
                style: {
                    padding: 0,
                    borderTop: 'none',
                    margin: 0,
                },
                content: (
                    <Flex
                        className={css(S.ModalFlexContainer)}
                        column={true}
                        onClick={handleBackgroundClick}
                    >
                        <Grid columns={pxArrayToRem([620, 480])}>
                            <Flex column={true}>{render.left}</Flex>
                            <Flex column={true}>{render.right}</Flex>
                        </Grid>
                    </Flex>
                ),
            }}
        />
    );
};
